import React from "react";

import { HeroCarousel as HeroCarouselProps } from "@reactivated";

import { Themed } from "../../styles/themes";
import { FullBleedMedia } from "../FullBleedMediaBlock";
import { Carousel } from "../GoodcookCarousel";
import { MediaChooserBlock } from "../MediaChooserBlock";
import { RichText } from "../RichText";

import styles from "./HeroCarousel.module.scss";

export function HeroCarousel({
    value,
    index,
}: {
    value: HeroCarouselProps;
    index?: number;
}) {
    return (
        <Themed theme="robinsBlue">
            <Carousel
                label={value.block_label!}
                containerProps={{ className: styles.root }}
                scrollContainerProps={{ className: styles.scrollContainer }}
                dotsClassName={styles.dots}
                controlsClassName={styles.controls}
            >
                {value.slides?.map(({ id: key, value: slide }) => (
                    <FullBleedMedia
                        key={key}
                        content={
                            slide.content ? (
                                <RichText
                                    headingSize="large"
                                    textAlignment="center"
                                    value={slide.content}
                                />
                            ) : null
                        }
                        isInCarousel={value.slides!.length > 1}
                        media={<MediaChooserBlock value={slide.media!} />}
                        mobileMedia={
                            slide.mobile_media &&
                            slide.mobile_media.length > 0 ? (
                                <MediaChooserBlock value={slide.mobile_media} />
                            ) : undefined
                        }
                        height={
                            index === 0 ? "heightFullMinusNav" : "heightFull"
                        }
                        theme="navy"
                    />
                ))}
            </Carousel>
        </Themed>
    );
}
